import React from 'react';
import {
  Heading,
  HeadingUnderLine,
  ActiveTabBox,
  SeparateContainer,
  SeparateInnerContainer,
  FlexContainer,
  Scores,
  LevelNameText,
  PerformanceScoreContainer,
} from '../styles';
import { CodeWrittenText } from './styles';

export default function testCases({ selectedInput }) {
  let correctnessLevels = selectedInput?.levelScores?.slice(
    0,
    selectedInput.levelScores.length - selectedInput.goodPerformanceScores.length
  );

  let correctnessLevelsName = selectedInput?.levelNames?.slice(
    0,
    selectedInput.performanceScores.length
      ? selectedInput.levelNames.length - selectedInput.levelScores.length - selectedInput.goodPerformanceScores.length
      : selectedInput.levelNames.length
  );

  let performanceLevels = selectedInput?.levelScores?.slice(
    selectedInput.levelScores.length - selectedInput.goodPerformanceScores.length,
    selectedInput.levelScores.length
  );

  let performanceLevelsName = selectedInput?.levelNames?.slice(
    selectedInput.levelNames.length - selectedInput.goodPerformanceScores.length,
    selectedInput.levelNames.length
  );

  let totalScore = selectedInput.levelScores.reduce(function (memo, num) {
    return memo + (num ? num : 0);
  }, 0);

  let totalMaxScore = selectedInput.levelMaxScores.reduce(function (memo, num) {
    return memo + (num ? num : 0);
  }, 0);

  const getPerformanceScore = function (index) {
    return typeof selectedInput.performanceScores[index] === 'number' &&
      selectedInput.performanceScores[index] <= selectedInput.goodPerformanceScores[index]
      ? selectedInput.performanceScores[index] + ' ms'
      : 'Timeout';
  };

  const getCorrectnessLevelScoreBoxColor = (levelScore, index) => {
    const calc = levelScore / selectedInput.levelMaxScores[index];
    if (selectedInput.levelScores[index] === 0) return 'bad';
    if (calc * 100 > 0 && calc * 100 <= 25) return 'poor';
    if (calc * 100 > 25 && calc * 100 <= 50) return 'fair';
    if (calc * 100 > 50 && calc * 100 <= 75) return 'good';
    if (calc * 100 > 75) return 'excellent';
  };

  const getGoodPerformanceLevelScoreBoxColor = (index) => {
    const calc = selectedInput.performanceScores[index];
    if (typeof calc !== 'number' || calc >= selectedInput.goodPerformanceScores[index]) return 'bad';
    if (typeof calc === 'number' && calc < selectedInput.goodPerformanceScores[index]) return 'excellent';
  };

  const getPerformanceLevelScoreBoxScore = (index) => {
    const calc =
      performanceLevels[index] /
      selectedInput.levelMaxScores[selectedInput.levelMaxScores.length - performanceLevels.length - 1 + index];
    if (performanceLevels[index] === 0) return 'bad';
    if (calc * 100 > 0 && calc * 100 <= 25) return 'poor';
    if (calc * 100 > 25 && calc * 100 <= 50) return 'fair';
    if (calc * 100 > 50 && calc * 100 <= 75) return 'good';
    if (calc * 100 > 75) return 'excellent';
  };

  const getTotalScoreBoxScore = () => {
    const calc = (totalScore / totalMaxScore) * 100;
    if (totalScore === 0) return 'bad';
    if (calc > 0 && calc <= 25) return 'poor';
    if (calc > 25 && calc <= 50) return 'fair';
    if (calc > 50 && calc <= 75) return 'good';
    if (calc > 75) return 'excellent';
  };

  const renderTestCases = () => {
    return (
      <>
        {correctnessLevels.length && (
          <>
            <CodeWrittenText>Correctness test cases:</CodeWrittenText>
            {correctnessLevels.map((levels, index) => {
              return (
                <FlexContainer key={`correctnessLevels${index}`} alignItemsCenter={true}>
                  <LevelNameText>{correctnessLevelsName[index]}</LevelNameText>
                  <Scores color={getCorrectnessLevelScoreBoxColor(levels, index)}>{`${levels} / ${
                    selectedInput.levelMaxScores[index] ?? 1
                  }`}</Scores>
                </FlexContainer>
              );
            })}
          </>
        )}
        {performanceLevels.length > 0 && (
          <>
            <CodeWrittenText>Performance test cases:</CodeWrittenText>
            {performanceLevels.map((levels, index) => {
              return (
                <FlexContainer key={`performanceLevels${index}`} alignItemsCenter={true}>
                  <LevelNameText>
                    {performanceLevelsName[index]} (Max time limit: {`${selectedInput.goodPerformanceScores[index]} ms`}
                    )
                  </LevelNameText>
                  <PerformanceScoreContainer>
                    <Scores color={getGoodPerformanceLevelScoreBoxColor(index)} marginRight={'2px'}>
                      {getPerformanceScore(index)}
                    </Scores>
                    <Scores color={getPerformanceLevelScoreBoxScore(index)}>{`${levels} / ${
                      selectedInput.levelMaxScores[
                        selectedInput.levelMaxScores.length - selectedInput.performanceScores.length - 1 + index
                      ]
                    }`}</Scores>
                  </PerformanceScoreContainer>
                </FlexContainer>
              );
            })}
          </>
        )}
        {correctnessLevels.length + performanceLevels.length && (
          <FlexContainer alignItemsCenter={true} marginTop={'20px'}>
            <CodeWrittenText>Total:</CodeWrittenText>
            <Scores color={getTotalScoreBoxScore()}>{`${totalScore} / ${totalMaxScore}`}</Scores>
          </FlexContainer>
        )}
      </>
    );
  };

  return (
    <SeparateContainer extraBoxWithShadow={true}>
      <SeparateInnerContainer extraBoxWithShadow={true}>
        <ActiveTabBox>
          <Heading>TEST CASES - {selectedInput.isBestRun ? 'BEST CODE SCORE' : 'SELECTED CODE SCORE'} </Heading>
          <HeadingUnderLine />
          {renderTestCases()}
        </ActiveTabBox>
      </SeparateInnerContainer>
    </SeparateContainer>
  );
}
